module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "id",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "key",
      "prop": "k",
      "width": "250px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "value",
      "prop": "v",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "m",
      "width": "200px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ID",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增设置' : '编辑设置',
      "visible": _vm.addDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "key"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.k),
      callback: function($$v) {
        _vm.$set(_vm.form, "k", $$v)
      },
      expression: "form.k"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "value"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 10,
        maxRows: 100
      }
    },
    model: {
      value: (_vm.form.v),
      callback: function($$v) {
        _vm.$set(_vm.form, "v", $$v)
      },
      expression: "form.v"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.m),
      callback: function($$v) {
        _vm.$set(_vm.form, "m", $$v)
      },
      expression: "form.m"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAdd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eee327e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/device.vue
// module id = 1116
// module chunks = 2